'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import { useMemo } from 'react';
import { useCursorPagination } from '@/hooks/useCursorPagination';
import { fetchMarketLiquidationsPage, marketLiquidationsTableQueryKey } from '../config/queryKey';
interface UseLiquidationTableDataParams {
  chainId: ChainId;
  marketId: string;
  first: number;
  timestampGte?: number;
  timestampLte?: number;
}

/**
 * Cursor-paginated data hook for the market liquidation table, over
 * `market.liquidations`: sorted by timestamp DESC, filtered only by the
 * optional date range.
 */
const useLiquidationTableData = t0 => {
  const $ = _c(14);
  const {
    chainId,
    marketId,
    first,
    timestampGte,
    timestampLte
  } = t0;
  let t1;
  if ($[0] !== chainId || $[1] !== first || $[2] !== marketId || $[3] !== timestampGte || $[4] !== timestampLte) {
    t1 = {
      chainId,
      marketId,
      timestampGte,
      timestampLte,
      limit: first
    };
    $[0] = chainId;
    $[1] = first;
    $[2] = marketId;
    $[3] = timestampGte;
    $[4] = timestampLte;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const queryFilters = t1;
  let t2;
  if ($[6] !== queryFilters) {
    t2 = marketLiquidationsTableQueryKey(queryFilters);
    $[6] = queryFilters;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== queryFilters) {
    t3 = cursor => fetchMarketLiquidationsPage(queryFilters, cursor);
    $[8] = queryFilters;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = `${chainId}:${marketId}:${timestampGte ?? "-"}:${timestampLte ?? "-"}:${first}`;
  let t5;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      resetKey: t4
    };
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return useCursorPagination(t5);
};
export default useLiquidationTableData;